<app-nav></app-nav>
<section class="refer">
  <div class="container">
    <section class="refer-friend" *ngIf="referInfoSection">
      <img src="assets/images/refer.jpg" />
      <h5 class="head">Refer a product to a friend & earn upto <span>500</span> Wallet points* on valid referrals</h5>
      <div class="refer-btm">
        <h5>How it works?</h5>
        <ul>
          <li><div class="circle">1</div> Refer a product to a friend</li>
          <li><div class="circle">2</div> Get 100 wallet points when friend Sign-up</li>
          <li><div class="circle">3</div> Get 100 wallet points when friend purchases a product</li>
          <li><div class="circle">4</div> Redeem wallet points & get an Amazon voucher</li>
        </ul>
        <p>*1point = ₹1</p>
        <p>*The scheme is open only for people insured by Securenow</p>
      </div>
      <!-- <div class="refer-text">
        <img src="assets/images/refer-men.jpg" />
        <div class="refer-con">
          <h6>What you have to do</h6>
            <div class="todoList">
              <label>Refer 3 friends</label>
              <label>Friends sign up</label>
              <label>You get a voucher</label>
            </div>
        </div>
        <div class="clearfix"></div>
      </div> -->

      <!-- enable refer product for all user -->
      <!-- <button class="btn btn-orange mt-4 btn-padding" [disabled]="referBtn? true:null" -->
        <!-- <button class="btn btn-orange mt-4 btn-padding"  -->
             <button class="btn btn-orange mt-4 btn-padding" [disabled]="referBtn && referBtn2"
        (click)="referFormSection = true; referInfoSection = false;">Refer Product</button>
    </section>
    <section class="refer-form-section" *ngIf="referFormSection">
      <h5>Enter details of your friend</h5>
      <form #referForm="ngForm" (ngSubmit)="submitReferral()">
        <div class="form-group">
          <label class="required">Name of the Person</label>
          <input type="text" class="form-control" maxlength="100" pattern="^[a-zA-Z ]+$" #name="ngModel" name="name"
            [(ngModel)]="refer.name" placeholder="Name" required>
          <div *ngIf="name.invalid && name.touched " class="error-message">
            <div *ngIf="name.errors.required">
              Name is required.
            </div>
            <div *ngIf="name.errors.pattern">
              Please enter the valid name.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="required">Mobile No.</label>
          <input type="text" class="form-control" #mobile="ngModel" name="mobile" minlength="10" maxlength="10"
            [(ngModel)]="refer.mobile" (keydown.space)="$event.preventDefault();" inputmode="numeric" pattern="^((?!(0))[0-9]{1,10}\d*)$" placeholder="Mobile No." required />
          <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
            <div *ngIf="mobile.errors.required">
              Mobile number is required.
            </div>
            <div *ngIf="mobile.errors.minlength && !mobile.errors.pattern">
              Mobile number must be 10 digits long.
            </div>
            <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
              Invalid mobile number.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="required">E-mail</label>
          <input type="text" class="form-control" maxlength="100" #email="ngModel" name="email" [(ngModel)]="refer.email"
          pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$" placeholder="Email address" required />
          <div *ngIf="email.invalid && email.touched " class="error-message">
            <div *ngIf="email.errors.required">
              Email is required.
            </div>
            <div *ngIf="email.errors.pattern">Email must be a valid email address</div>
          </div>
        </div>
        <div class="form-group">
            <ng-select class="custom"></ng-select>
          <label class="required">City</label>
          <input type="text" class="form-control" [typeahead]="cityList"
            (typeaheadOnSelect)="selectCity($event)" (focusout)="checkCityValue($event)" maxlength="100" [isAnimated]="true" #location="ngModel" name="location"
            [(ngModel)]="refer.location" placeholder="City" required />
          <div *ngIf="location.invalid && location.touched " class="error-message">
            <div *ngIf="location.errors.required && !noResult">
              City is required.
            </div>
          </div>
          
          <div *ngIf="noResult" class="error-message">No results found!</div>
        </div>
        <!--As discussed these Insurance values is hard coded for now-->
        <div class="form-group">
          <label class="required">Product</label>
          <select class="form-control ng-dirty ng-valid ng-touched" #product="ngModel" name="product" [(ngModel)]="refer.product" (change)="selectedProduct($event)" required>
            <option value="" selected disabled>Select Product</option>
            <option value="95">Health Insurance</option>
            <option value="23">Motor Insurance</option>
            <option value="129">Personal Accident</option>
            <option value="83">Doctors Indemnity</option>

            <option value="129">Term Life</option>
            <option value="150">Hospital Cash</option>
            <option value="4">Workmen Compensation</option>
            <option value="93">Specific Marine Transit</option>
            <option value="1">Group Health Insurance</option>
          </select>
          <div *ngIf="product.invalid && product.touched" class="error-message">
            <div *ngIf="product.errors.required">
              Please select any product.
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Channel</label>
          <input type="text" class="form-control" value="Referral" [disabled]="true"/>
        </div>
        <div class="form-group">
          <label>Referred By (Mobile Number)</label>
          <input type="text" class="form-control" [value]='userMobile' [disabled]="true"/>
        </div>
        <div class="text-center">
          <button class="btn btn-orange mt-4 btn-padding" [disabled]="!referForm.valid || noResult">Refer Now</button>
        </div>
      </form>
    </section>
  </div>
</section>
<span id="snackbar"></span>
<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>